// weight-management/critical-review.tsx
import { makeid } from 'utils/helpers/makeid';

import type { TFormItem } from '../../types';

export const weightCriticalReviewConfig: TFormItem[] = [
  {
    key: makeid(10),
    name: 'weightRunbook',
    type: 'radio',
    title: <p>Weight Management — Critical Reading Review</p>,
    description:
      "Is there a runbook entry for this population's escalation preference?",
    required: true,
    options: [
      {
        key: makeid(10),
        label: 'Yes — enter the action it specifies',
        value: 'has-entry',
        hideSubitemsIfParentNotSelected: true,
        subItems: [
          {
            key: makeid(10),
            name: 'weightRunbookAction',
            type: 'input',
            title: <p>Runbook action</p>,
            required: true,
          },
        ],
      },
      {
        key: makeid(10),
        label: 'No entry — system default: Escalate to Clinic',
        value: 'no-entry',
      },
    ],
  },
  {
    key: makeid(10),
    name: 'weightMonthlyInteraction',
    type: 'radio',
    title: <p>Routine Monthly Interaction this month</p>,
    description: 'System-detected. If not completed, attempt now if possible.',
    required: true,
    options: [
      {
        key: makeid(10),
        label: 'Completed — no further action',
        value: 'completed',
      },
      {
        key: makeid(10),
        label: 'Not completed — attempt now',
        value: 'attempt-now',
      },
    ],
  },
];
